import axios from "axios";

export const fetchExportSubmission = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.post(`${baseTaskUrl}/TaskSubmission/export`, data, {
    responseType: "blob",
  });
};